import React from 'react'
import { useQuery, useQueries } from 'react-query'
import Loader from 'components/general/Loader';
import { filterArray, findArray } from "helpers/utils"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Label from "components/general/Label"
import { getConfigSports, getPoolStanding, getPhases } from "data/Querys"
import { getEventRSC, getLongPhaseRSC, getPhaseRSC, getEvent } from "helpers/rsc"
import PoolStanding from 'components/sports/glo/poolstanding/views/PoolStanding';
import ProgressionRule from 'components/common/ProgressionRule'
import NotAvailable from 'components/common/NotAvailable'
import { useViewport } from 'components/general/useViewPort'
import PageHeader from 'components/common/PageHeader';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { useGetConfigSports } from 'helpers/commonCodes';

function PoolStandingContext() {

    //Get data from url 
    const { mirs_competition, mirs_rsc, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
    const params = { 'mirs_competition': mirs_competition, 'mirs_discipline': mirs_discipline }
    const _event = getEventRSC(mirs_rsc);
    const _onlyEvent = getEvent(mirs_rsc);
    const { breakPoint } = useViewport();
    const dataConfigSport = useGetConfigSports(params);
    //Load data from config file

    let filter = breakPoint === 'sm' || breakPoint === 'xs' ? 'sm' : 'lg';
    let poolValues = dataConfigSport?.pool?.find(media => media.code === filter && media.codeEvent === _onlyEvent)?.table
    if (!poolValues) {
        poolValues = dataConfigSport?.pool?.find(media => media.code === filter)?.table
    }
    let combinedValues = dataConfigSport?.combinedRanking?.find(media => media.code === filter)?.table

    let isList = poolValues?.isList


    //Load data Phases
    const { data: phasesData, isError: phasesError, isLoading: phasesLoading } = useQuery(
        {
            queryKey: ['phasesData', mirs_competition, mirs_language, _event],
            queryFn: getPhases,
            enabled: isList, //--------------------
            refetchInterval: 60000,
            refetchIntervalInBackground: true,
        });

    //Filter phases we need
    let queryArray = [];
    //let phases = phasesData && filterArray(phasesData, { order: ['8  '] })

    let phases = phasesData && phasesData.filter(phase => phase?.order?.trim() === '8')


    if (!isList) {
        let phasesNounits = phases && phases.filter(item => !item.units)
        phases = phases && filterArray(phases, { code: [getPhaseRSC(mirs_rsc)] })
        phases = phases && [...phases, ...phasesNounits]
    }


    //Filter phases by order 8 (Pooles)
    phases && phases.forEach((phase) => {
        queryArray.push({
            queryKey: ['poolData', mirs_competition, getLongPhaseRSC(phase.code), mirs_language],
            queryFn: getPoolStanding,
            refetchInterval: 30000,
            staleTime: 30000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
        })
    });


    const pools = useQueries(queryArray);//Data all pools
    const isLoading = phasesLoading || pools.some(pool => pool.isLoading)
    const isError = phasesError || pools.some(pool => pool.isError)

    if (isError) { return <NotAvailable />; }
    if (isLoading) { return <Loader />; }


    if ((pools && pools.length < 1) || (pools && pools?.filter(p => p?.data?.poolStandings).length < 1)) return <NotAvailable />
    return (
        <>

            <PageHeader title={<Label data="LabelGroup" />} showEvent={true} />

            <div className='mirs-page-container'>

                {pools?.find(p => p?.data?.poolStandings?.extendedInfos !== undefined) && <ProgressionRule
                    //className='mx-2 mb-5'
                    data={pools?.find(p => p?.data?.poolStandings?.extendedInfos !== undefined)?.data?.poolStandings?.extendedInfos}
                    filter={{ ei_type: ['UI'], ei_code: ['QUAL_RULE'] }}
                    itemData='ei_value'
                />
                }

                {
                    dataConfigSport && dataConfigSport.hasCombinedRanking && !['RU7'].includes(mirs_discipline)
                        ? <Tabs
                            id="mirs-navsport"
                            className="mb-3"
                            defaultActiveKey={`1-${mirs_rsc}`}
                        >
                            <Tab eventKey={`1-${mirs_rsc}`} title={<Label data="Groups" sport={mirs_discipline} />} >
                                <DrawPooles pools={pools} phases={phases} columns={poolValues.columns} />
                            </Tab>

                            <Tab eventKey={`2-${mirs_rsc}`} title={<Label data="CombinedRanking" sport={mirs_discipline} />} >
                                <DrawPooles pools={pools} phases={phases} columns={combinedValues.columns} isCombined={true} />
                            </Tab>
                        </Tabs>
                        :

                        dataConfigSport && dataConfigSport.hasPool
                            ?
                            <>
                                <DrawPooles pools={pools} phases={phases} columns={poolValues.columns} />
                                {dataConfigSport && dataConfigSport.hasCombinedRanking && ['RU7'].includes(mirs_discipline)
                                    ? <DrawPooles pools={pools} phases={phases} columns={combinedValues.columns} isCombined={true} />
                                    : ''
                                }
                            </>
                            : ''
                }
            </div>
        </>
    );

}



const DrawPooles = ({ pools, phases, columns, isCombined = false }) => {

    return (
        pools.map((dataPool, index) => {
            let phaseRsc = getPhaseRSC(dataPool?.data?.poolStandings?.rsc);
            let check
            let label
            if (isCombined) {
                label = 'combined-ranking-component'
                check = phases && phaseRsc.endsWith("--")

            } else {
                label = 'pool-component'
                check = phases && !phaseRsc.endsWith("--")
            }
            return (
                // phases && findArray(phases, { code: [phaseRsc] }).units &&
                check &&
                <PoolStanding key={`${label}-${index}`} data={dataPool.data.poolStandings} columns={columns} isCombinedRanking={isCombined} />
            )
        })
    )


}

export default PoolStandingContext